// removed by extract-text-webpack-plugin
module.exports = {"container":"_2m6gPa2","list":"_1Sq1DvZ","recentSearchesHeader":"_3WFlxZM","recentSearchesClear":"_27Sj3UY"};


//////////////////
// WEBPACK FOOTER
// ./template/components/SearchDropdown/index.css
// module id = ./template/components/SearchDropdown/index.css
// module chunks = client.sitechrome